export const beforeAfterSlides = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/gfHC3rQ51GZhT3RGChbTap/WhatsApp_Image_2026-10-04_at_12.52.29_(2).jpg',
    alt: 'Kitchen before and after: dated wood cabinets and tiled counters transformed into white cabinets with a stone-look backsplash',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/9qJBrrwTQzXUKbRvqPdSev/WhatsApp_Image_2026-10-04_at_12.52.26_(2).jpg',
    alt: 'Small kitchen before and after: beige tiles replaced by a black accent wall, white subway tile, and marble-look floor',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/iQzmthJ7DKy5epGePSTSiT/WhatsApp_Image_2026-10-04_at_12.52.27_(1).jpg',
    alt: 'Dresser before and after: scratched dark wood repainted cream with a wood top and brass pulls',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/n6j8Zo5xfg9dava3KwB3wf/WhatsApp_Image_2026-10-04_at_12.52.29_(3).jpg',
    alt: 'Galley kitchen before and after: worn green cabinets refreshed with wood-tone fronts and a patterned tile backsplash',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/ubiUZSKc4YSt8M8uPNCnPB/WhatsApp_Image_2026-10-04_at_12.52.28.jpg',
    alt: 'Laundry room before and after: dark terrazzo floor covered with warm wood-look flooring',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/7vnFHKmW7vbEsEcTcHLn9P/WhatsApp_Image_2026-10-04_at_12.52.29_(4).jpg',
    alt: 'Bathroom before and after: old green tiles updated with white subway tile, sage paint, and wood accents',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/2bFhFbYigzo7DV9HfUoja8/WhatsApp_Image_2026-10-04_at_12.52.30_(1).jpg',
    alt: 'Kitchen backsplash before and after: red square tiles covered with white marble-look panels',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/3inEQth4jtDLZv9U3Me6M1/WhatsApp_Image_2026-10-04_at_12.52.27_(2).jpg',
    alt: 'U-shaped kitchen before and after: orange wood cabinets repainted muted teal with open shelves and warm lighting',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/nk2HZVPoTcZr1raEirE77r/WhatsApp_Image_2026-10-04_at_12.52.30_(2).jpg',
    alt: 'Bathroom before and after: beige tiles transformed into white marble-look walls and floor',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/9AzBCQM2twvDXTCY6y1N45/WhatsApp_Image_2026-10-04_at_12.52.29_(5).jpg',
    alt: 'Hutch before and after: weathered dark wood cabinet repainted sage green with patterned wallpaper backing',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/bVafFX3A2yZkBRhMFnTdfr/WhatsApp_Image_2026-10-04_at_12.52.27_(4).jpg',
    alt: 'Basement floor before and after: cracked concrete painted a smooth gray in a finished office',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/9xvCPWms9t7Uz8sC7HrRPq/WhatsApp_Image_2026-10-04_at_12.52.28_(1).jpg',
    alt: 'Floor before and after: green terrazzo covered with wood-look vinyl planks',
  },
]
